'use strict';

exports.__esModule = true;
exports.create = create;

var _quCheck = require('../utils/qu-check');

var _http = require('../network/http');

var _http2 = _interopRequireDefault(_http);

var _modelProvider = require('../model-provider');

var _modelProvider2 = _interopRequireDefault(_modelProvider);

var _apiClient = require('../network/api-client');

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Add order to a job
 * @param {Object} attrs - Attributes
 * @param {string} [attrs.jobId] - order number associated with the job
 * @param {string} [attrs.description] - free text displayed on the order
 * @returns {promise} containing the entity object of order
 */
function create() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var jobId = attrs.jobId,
      orderNumber = attrs.orderNumber,
      description = attrs.description,
      fromWaypointId = attrs.fromWaypointId,
      toWaypointId = attrs.toWaypointId,
      paymentMode = attrs.paymentMode;

  _quCheck.checker.warn(_quCheck.common.jobId, jobId);
  _quCheck.checker.warn(_quCheck.checker.number, fromWaypointId);
  _quCheck.checker.warn(_quCheck.checker.number, toWaypointId);

  return _http2.default.post('/customer/jobs/' + (jobId || orderNumber) + '/orders', {
    jobId: jobId,
    description: description,
    fromWaypointId: fromWaypointId,
    toWaypointId: toWaypointId,
    paymentMode: paymentMode
  }).then(function (order) {
    return _modelProvider2.default.Order(order, { jobId: jobId, fromWaypointId: fromWaypointId, toWaypointId: toWaypointId });
  });
}

/**
 * Update the order
 * @param {Object} order data
 * @returns {Promise} that resolves the new order
 */
var update = function update(payload) {
  var jobId = payload.jobId,
      id = payload.id;


  return _apiClient2.default.put({
    route: '/customer/jobs/' + jobId + '/orders/' + id,
    data: payload,
    includeAuth: true
  });
};

/**
 * Remove the order
 * @param {Object} order data
 * @returns {Promise} that resolves when the order is removed
 */
var remove = function remove(payload) {
  var jobId = payload.jobId,
      id = payload.id;


  return _apiClient2.default.remove({
    route: '/customer/jobs/' + jobId + '/orders/' + id,
    includeAuth: true
  });
};

exports.default = {
  create: create,
  update: update,
  remove: remove
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/customer/orders.js
// module id = 284
// module chunks = 0